export default __webpack_public_path__ + "static/media/cloths.119b4568.jpg";